<template>
	<!-- thanks -->
	<div class="columns is-multiline is-mobile is-padded-left-mobile">
		<div class="column is-full-touch is-full-desktop thumbs-icon"></div>
		<div class="column is-full-touch is-full-desktop has-text-centered">
			<p><b class="title is-3">{{ translation.confirmed }}</b></p>
			<div class="column is-offset-3 is-half has-text-centered">
				<p><b class="title is-6 has-text-weight-bold has-text-black-ter">{{ translation.mail }}</b></p>
			</div>
		</div>
		<div class="column is-full-mobile is-5-desktop is-offset-1-desktop is-padded-left-more is-padded-right-more justify-text has-text-centered-mobile">
			<div class="form-icon"></div>
			<p><b>{{ translation.mandate.title }}</b></p>
			<p>{{ translation.mandate.content }}</p>
		</div>
		<div class="column is-full-mobile is-5-desktop is-padded-left-more is-padded-right-more justify-text has-text-centered-mobile">
			<div class="trophy-icon"></div>
			<p><b>{{ translation.order.title }}</b></p>
			<p>{{ translation.order.part1 }}</p>
			<p></p>
			<p>{{ translation.order.part2 }}</p>
		</div>
		<div class="column has-text-centered is-full-touch is-full-desktop is-marged-bottom">
			<a class="button is-emv" :href="redirection">{{ translation.link }}</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		translation: {
			type: Object,
			required: true,
		},
		redirection: {
			type: String,
			required: true,
		},
	}
}
</script>

<style lang="sass" scoped>
	.thumbs-icon
		background-image: url("/images/thumb_icon.svg")
		background-position: center
		background-size: contain
		background-repeat: no-repeat
		height: 60px
		margin-top: 25px
	.form-icon
		background-image: url("/images/form_icon.svg")
		background-size: contain
		background-repeat: no-repeat
		height: 60px
		margin-bottom: 10px
	.trophy-icon
		background-image: url("/images/trophy_icon.svg")
		background-size: contain
		background-repeat: no-repeat
		height: 60px
		margin-bottom: 10px
	.justify-text p
		font-weight: 500
	@media (max-width: 768px)
		.trophy-icon
			background-position: center
		.form-icon
			background-position: center
</style>
